import { Injectable } from '@angular/core';
import { GetDeliveryMomentsResponse } from '@next/core-lib/cart';
import { Observable } from 'rxjs';
import { ProductWizardMode } from 'src/app/product/models/product.models';
import { CartApiService } from 'src/app/product/services/cart-api.service';
import { ProductDeliveryMomentApiService } from 'src/app/product/services/product-delivery-moment-api.service';

@Injectable({
  providedIn: 'root',
})
export class DeliveryInformationService {
  constructor(
    private readonly cartApiService: CartApiService,
    private readonly productDeliveryMomentService: ProductDeliveryMomentApiService,
  ) {}

  getDeliveryMoments(
    wizardMode: ProductWizardMode,
    skuId: number,
    cartId?: number,
    cartLineId?: string,
    flexibility = 0,
  ): Observable<GetDeliveryMomentsResponse> {
    switch (wizardMode) {
      case ProductWizardMode.EDIT:
        return this.cartApiService.getCartLineDeliveryMoments(cartId, cartLineId, flexibility);
      case ProductWizardMode.CART:
        return this.cartApiService.getCartDeliveryMoments(cartId, undefined, flexibility);
      case ProductWizardMode.ADD:
      default:
        return this.productDeliveryMomentService.getDeliveryMoments(skuId, undefined, flexibility);
    }
  }
}
